import { render, staticRenderFns } from "./PromotionRowOfferPresentationMBRExp.vue?vue&type=template&id=13f41b49&scoped=true"
import script from "./PromotionRowOfferPresentationMBRExp.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionRowOfferPresentationMBRExp.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionRowOfferPresentationMBRExp.vue?vue&type=style&index=0&id=13f41b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f41b49",
  null
  
)

export default component.exports